import { HttpBackend, HttpClient, HttpHeaders} from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA, HostBinding, HostListener, Inject, NgModule, NO_ERRORS_SCHEMA, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, NgModel } from '@angular/forms';
import { DwComponent, DwComponentSectionConfigPreference, DwComponentType, DwExpressionService, DwMessagingService, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwModalButtonStandardConfigs, DwModalConfig, DwModalService, DwModalSize, DwOrmDataService, DwOrmDataServiceToken, DwQueryHelper, DwSectionBaseComponent, DwSecurityRepositoryService, DwSecurityRepositoryServiceToken, DwSecurityUserService, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken } from '@devwareapps/devware-cap';
import { ConfigService } from 'src/environments/environment';
import { FileExplorerConfig } from '../models/file-explorer-config.model';
import { FileExplorerConfigComponent } from './file-explorer-config/file-explorer-config.component';
import { Folder } from '../models/folder';
import {FileClass} from '../models/file';
import {FileApi} from '../models/fileApi';
import { FolderAPI } from '../models/folderApi';
import { FolderApiPost } from '../models/folderApiPost';
import { AppMetaDataService } from 'src/app/meta-data/app-meta-data.service';
import * as moment from 'moment';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { LottieModule } from 'ngx-lottie';
import { NewFolderModelComponent } from './new-folder-model/new-folder-model.component';
import { flatMap } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { UploadFileModalComponent } from './upload-file-modal/upload-file-modal.component';
import {saveAs} from 'file-saver';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';
import { ElementFlags } from 'typescript';

@DwComponent({
  name: 'FileExplorer',
  isGlobal: true,
  componentType: DwComponentType.formSection,
  configComponent : FileExplorerConfigComponent
})
@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-file-explorer',
  templateUrl: './file-explorer.component.html',
  styleUrls: ['./file-explorer.component.scss']
})
export class FileExplorerComponent extends DwSectionBaseComponent<DwComponentSectionConfigPreference<FileExplorerConfig>> implements OnInit {
  folders: Folder[]
  selectedFolderId: number;
  files: FileClass[];
  moment: any = moment;
  public backgroundColor = '#fff';
  options: AnimationOptions = {
    path: '/assets/lottie/wachter_loading.json',
  };
  fileDropOptions: AnimationOptions = {
    path: '/assets/lottie/file_drop.json'
  }
  fileBeingDropped: boolean = false;
  loaded: boolean = false;
  attachmentId: number;
  searchQuery: string;
  trustId: number = 0;
  http: HttpClient;
  eventsSubject: Subject<void> = new Subject<void>();
  oldAttachmentId: number;
  FileExplorerConfig: FileExplorerConfig;
  isDev = !ConfigService.config.production

  constructor(private renderer:Renderer2,
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
    @Inject(DwMetaDataFormStateService) private dwMetaDataFormStateService: DwMetaDataFormStateService,
    private dwModalService: DwModalService,
    httpBackend: HttpBackend,
    private securityService: DwSecurityUserService,
    ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    this.http = new HttpClient(httpBackend);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.FileExplorerConfig = this.sectionConfig.config;

    this.attachmentId = this.getFileIdControl(this.FileExplorerConfig.attachmentId).value;

    this.delay(300).then(() => {
      if (this.attachmentId == null){

      }
      this.getFolders(this.attachmentId);
      const wachterUser = new WachterUserExt(this.securityService.securityContext.ApplicationUser);
      this.trustId = wachterUser.trustUserId;
    })

  }


  getFileIdControl(attrName: string): FormControl {
    const md = new AppMetaDataService();

    return this.getOrCreateFormControl(attrName);
  }

  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

  setAttachmentId(): number{

    return 0;
  }

  folderSelected(folderId: number){
  console.log(folderId);
  this.selectedFolderId = folderId;
    this.getFiles(this.attachmentId, folderId);
  }

  fileClicked(FileId: number){
    console.log(FileId);
  }

  onRightClick(event) {
    console.log('Right click')
    return false;
  }

  fileDblClicked(FileId: number, FileName: string){
    this.downloadFile(FileId, FileName);
  }

  downloadFolderBtn(){
    this.downloadFolder(this.selectedFolderId);

  }

  downloadFolder(FolderId: number){
    let url = ConfigService.config.wAppsApi + 'api/FileExplorer/FilesZip?FolderId=' + FolderId;
    this.http.get(url, {observe: 'response', responseType: "blob"})
    .subscribe(res=>{

      saveAs(res.body, this.getFileNameFromHttpResponse(res.headers.get('Content-Disposition')))
    })
  }

  downloadFile(FileId: number, FileName: string) {
    let url = ConfigService.config.wAppsApi + 'api/FileExplorer/File?AttachmentFileId=' + FileId;
    console.log(FileName);
    this.http.get(url, {responseType: "blob"})
        .subscribe(res=>{
          saveAs(res, FileName)
        })
  }

  onNewFolder(){
    let modalConfig = new DwModalConfig();

    const md = new AppMetaDataService();
    modalConfig.allowFullScreen = true;
    modalConfig.cloneData = false;
    modalConfig.modalSize = DwModalSize.responsive;
    modalConfig.data = {

    }
    modalConfig.component = NewFolderModelComponent;

    modalConfig.title = 'New Folder';
    modalConfig.buttons = DwModalButtonStandardConfigs.instance.SaveAndClose;

    this.dwModalService.showModal(modalConfig).subscribe(result =>{
      if (!result.cancelled){
        console.log(result.data);
        this.createNewFolder(this.attachmentId, result.data, this.selectedFolderId, 0);
      }
    })
  }

  createNewFolder(AttachmentId: number, FolderName: string, ParentFolderId: number, TrustUserId: number){
    console.log("Creating Folder with ParentId " + ParentFolderId);
    var data: FolderApiPost = {FolderName: FolderName, ParentFolderId: ParentFolderId, TrustUserId: TrustUserId};
    let url = ConfigService.config.wAppsApi + 'api/FileExplorer/Folder?AttachmentId=' + AttachmentId;
    this.http.post(url, data).subscribe(result =>{
      console.log(result);
      this.getFolders(this.attachmentId);
    });
  }

  getFileNameFromHttpResponse(contentDispositionHeader) {
    var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
    return result.replace(/"/g, '');
}

  uploadFile(AttachmentId: number, FileName: string, TrustUserId: number, FolderId: number, FileArray: ArrayBuffer)
  {
    let url = ConfigService.config.wAppsApi + 'api/FileExplorer/File?AttachmentId=' + AttachmentId + '&FileName=' + FileName + '&TrustUserId=' + TrustUserId + '&FolderId=' + FolderId;
    const formData = new FormData();
    var blob = new Blob([FileArray])
    var newFile: File = new File([blob], FileName);
    formData.append('files', new Blob([FileArray]));
    /* let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'multipart/form-data');
    let httpOptions = {
      headers: headers
    } */
    this.http.post(url, formData).subscribe(x => {
      console.log(x);
      this.getFiles(this.attachmentId, this.selectedFolderId);
    })

  }

  onUpload(){
    let modalConfig = new DwModalConfig();

    const md = new AppMetaDataService();
    modalConfig.allowFullScreen = true;
    modalConfig.cloneData = false;
    modalConfig.modalSize = DwModalSize.responsive;
    modalConfig.data = {

    }
    modalConfig.component = UploadFileModalComponent;

    modalConfig.title = 'Upload File';
    modalConfig.buttons = DwModalButtonStandardConfigs.instance.SaveAndClose;

    this.dwModalService.showModal(modalConfig).subscribe(result =>{
      if (!result.cancelled){
        console.log(result.data);
        var file: FileList = result.data;

         file[0].arrayBuffer().then(data => {
          this.uploadFile(this.attachmentId, file[0].name, this.trustId, this.selectedFolderId, data);
        })
      }
    })
  }

  onSearch(searchString: string){
    this.searchQuery = searchString;
  }

  getUser(trustId: number) {
    const md = new AppMetaDataService();
    const qh = new DwQueryHelper();

    const query = md.RoEthosUser.CreateQuery()
    query.AddFilterAnd(qh.filters.Equal(md.RoEthosUser.UserId, trustId))
    const results = this.dataService.executeQuery(query);
    return results;
  }

  getFiles(attachmentId: number, folderId?: number){
    let url = ''
    if (folderId == null){
       url = ConfigService.config.wAppsApi + 'api/FileExplorer/File?AttachmentId=' + attachmentId;
    }
    else {
      url = ConfigService.config.wAppsApi + 'api/FileExplorer/File?AttachmentId=' + attachmentId + '&FolderId=' + folderId;
    }
    let Files = this.http.get(url);
    this.files = [];
    Files.subscribe(x =>{
      let files: FileApi[] = x as FileApi[];
      files.forEach(file => {
        this.getUser(file.CreatedBy).toPromise().then(user => {
        this.files.push({FileId: file.AttachmentFileId, FileName: file.CurrentDisplay, FolderParent: file.AttachmentFolderId, selected: false, Size: file.Size, CreatedBy: user[0]['NameLastFirstPrefered'], CreatedDate: file.CreatedDateTime});
        this.loaded = true;
      })
      })
    }
    );
    this.loaded = true;
  }

  getFolders(AttachmentId: number, ParentFolderId?: number){
    let url = ''
    if (ParentFolderId == null){
       url = ConfigService.config.wAppsApi + 'api/FileExplorer/Folder?AttachmentId=' + AttachmentId;
    }
    else {
      url = ConfigService.config.wAppsApi + 'api/FileExplorer/File?AttachmentId=' + AttachmentId + '&ParentFolderId=' + ParentFolderId;
    }
    let Folders = this.http.get(url);
    this.folders = [];
    return Folders.subscribe(x =>{
      let folders: FolderAPI[] = x as FolderAPI[];
      this.folders = folders;
    }
    );
  }



  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileBeingDropped = true;
  };

  //Dragleave listener, when something is dragged away from our host element
  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileBeingDropped = false;

  }

  @HostListener('drop', ['$event']) public ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    let files: FileList = evt.dataTransfer.files;
    this.fileBeingDropped = false;
    console.log(files.length);
    if (files.length > 0) {
      Array.from(files).forEach(element => {
        element.arrayBuffer().then(x => {
          this.uploadFile(this.attachmentId, element.name, this.trustId, this.selectedFolderId, x)
        })
      })
    }

  }
}
